import { render, staticRenderFns } from "./RecebimentoDeNotaFiscalListView.vue?vue&type=template&id=bfbcf4cc&scoped=true"
import script from "./RecebimentoDeNotaFiscalListView.vue?vue&type=script&lang=js"
export * from "./RecebimentoDeNotaFiscalListView.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDeNotaFiscalListView.vue?vue&type=style&index=0&id=bfbcf4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbcf4cc",
  null
  
)

export default component.exports